import { FETCH_RATES_SUCCESS, FETCH_RATES_FAILURE, FETCH_RATES_REQUEST, FETCH_RATES_RESET, } from "../../actions";
const initialState = {
    carrierRates: null,
    isLoading: false,
    error: null,
};
const RateReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_RATES_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, carrierRates: null });
        case FETCH_RATES_SUCCESS:
            return Object.assign(Object.assign({}, state), { carrierRates: action.payload, isLoading: false, error: null });
        case FETCH_RATES_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case FETCH_RATES_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: false, carrierRates: null, error: null });
        default:
            return state;
    }
};
export default RateReducer;
